import { Variant } from "../../types/types";

export const isFutureRelease = (variant: Variant) =>
  !!variant.availability?.futureAvailability;
